import { render, staticRenderFns } from "./MedicationCrud.vue?vue&type=template&id=f2144fcc&"
import script from "./MedicationCrud.vue?vue&type=script&lang=js&"
export * from "./MedicationCrud.vue?vue&type=script&lang=js&"
import style0 from "./MedicationCrud.vue?vue&type=style&index=0&id=f2144fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports